module.exports = __webpack_public_path__ + "static/media/5D.eda01110.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5D.svg
// module id = 66
// module chunks = 0